import React, { Component } from 'react';
import { Image, StyleSheet, Text, Pressable, View } from 'react-native';

import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';

import { COLOR, FONT, FONT_SIZE, FONT_FAMILY, THEME } from '../../constants/styles';

const MONTHS = [
  '',
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];

import {
  OPComponent,
  Container,
  DateUtils,
  Navigation,
  I18n,
  OPPureComponent,
} from '../components';

const localizer = momentLocalizer(moment);

const styles = StyleSheet.create({
  ...THEME,
  header: {
    height: 50,
    paddingVertical: 10,
    paddingLeft: 15,
    paddingRight: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderBottomColor: COLOR.altAccent,
    borderBottomWidth: 1,
  },
  headerText: {
    ...THEME.headerText,
    fontSize: 16,
    color: COLOR.text,
    textAlign: 'left',
  },
  calendarViewText: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 10,
    borderBottomColor: COLOR.emphasis,
  },
  floating: {
    border: `1px solid ${COLOR.altAccent}`,
    minWidth: 100,
    minHeight: 200,
    boxShadow: `0px 0px 5px ${COLOR.altAccent}`,
  },
  leftRightArrowContainer: {
    borderWidth: 1,
    borderColor: 'rgb(200, 200, 200)',
    backgroundColor: COLOR.contrast,
    borderRadius: 50,
    width: 50,
    height: 50,
    alignContent: 'center',
    alignItems: 'center',
    boxShadow: `0 5px 20px 0 rgba(0,0,0,0.10)`,
  },
  leftRightArrow: {
    marginVertical: 'auto',
    width: 18,
    height: 12,
    tintColor: COLOR.textLight,
  },
  agendaViewContainer: {
    flex: 0.3,
    marginRight: 40,
    borderColor: COLOR.altAccent,
    borderWidth: 1,
  },
  noEventsContainer: {
    marginVertical: 'auto',
    marginHorizontal: 20,
    paddingBottom: 40,
  },
  noEventsImageContainer: {
    shadowOffset: { height: 0, width: 0 },
    shadowOpacity: 0.5,
    shadowRadius: 7,
    shadowColor: COLOR.overlay,
    borderRadius: 120,
    height: 120,
    width: 120,
    marginVertical: 20,
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    tintColor: COLOR.emphasis,
  },
  noEventsImage: {
    margin: 'auto',
    height: 50,
    width: 50,
    resizeMode: 'contain',
  },
  noEventsText: {
    ...THEME.headerText,
    color: COLOR.text,
    marginVertical: 20,
  },
  noEventsDetailText: {
    ...THEME.textRegular,
    textAlign: 'center',
  },
  todayButton: {
    borderColor: 'rgb(221, 221, 221)',
    borderWidth: 2,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    width: 87,
    height: 40,
  },
  todayButtonText: {
    color: COLOR.textLight,
  },
  todayButtonContainer: {
    alignContent: 'center',
    alignItems: 'center',
  },
  timeframesContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

function AgendaView(props) {
  const { events, selectedDate, isMilitaryEmployer } = props;

  renderEvent = ({ event }) => {
    return props.renderItem(event);
  };
  getSelectedDate = () => {
    return selectedDate;
  };

  return (
    <View style={[styles.floating, styles.agendaViewContainer]}>
      <View style={styles.header}>
        <Text style={styles.headerText}>
          {DateUtils.formatDateString(selectedDate)} {I18n.c1('calendar.events')}
        </Text>
      </View>
      {events?.length > 0 ? (
        <BigCalendar
          localizer={localizer}
          events={events}
          titleAccessor="eventName"
          resourceTitleAccessor="eventId"
          startAccessor="startDate"
          endAccessor="endDate"
          // end common props
          toolbar={false}
          getNow={this.getSelectedDate}
          views={['agenda']}
          components={{
            agenda: {
              event: this.renderEvent,
            },
          }}
          defaultView="agenda"
        />
      ) : (
        <View style={styles.noEventsContainer}>
          <View style={styles.noEventsImageContainer}>
            <Image
              style={styles.noEventsImage}
              source={require('../../../resources/nav-icon-calendar.png')}
            />
          </View>
          <Text style={styles.noEventsText}>{I18n.t('calendar.noEvents')}</Text>
          <Text style={styles.noEventsDetailText}>
            {!isMilitaryEmployer ? (
              <Text>
                {I18n.t('calendar.noEventsDetail')} "
                <Text style={{ color: COLOR.emphasis }}>+</Text>" button.
              </Text>
            ) : null}
          </Text>
        </View>
      )}
    </View>
  );
}

class EventWrapperView extends Component {
  render() {
    const child = React.Children.only(this.props.children);
    let className = child.props.className;
    if (new Date(this.props.event.endDate) < new Date()) className += ' rbc-ispast';
    return React.cloneElement(child, { className });
  }
}
class CalendarView extends OPPureComponent {
  constructor(props) {
    super(props);

    this.state = {
      calendarView: 'month',
    };
  }

  handleDrillDown = (start) => {
    this.selectSlot({ start });
  };
  selectSlot = (slotInfo) => {
    this.props.setSelectedDate(slotInfo.start);
  };

  selectEvent = (event, sEvent) => {
    // console.log('selectEvent from CalendarView', event, sEvent);
    this.props.onSelectEvent(event);

    // not great relying on requestAnimationFrame instead of a navigation callback
    // but since the popup showing the '+N more' on calendar shouldn't show
    // when a modal is open, we want to force a re-render on our PureComponent
    // keeping tracking of a popup state that is linked to modal state is a bad linkage
    // since modal being dismissed is causing a re-render anyways
    requestAnimationFrame(() => {
      this.forceUpdate();
    });
  };

  selectToday = () => this.props.setSelectedDate(new Date());
  setCalendarViewWeek = () => {
    this.setState({ calendarView: 'week' });
  };
  setCalendarViewMonth = () => {
    this.setState({ calendarView: 'month' });
  };
  getSelectedDate = () => {
    return this.props.selectedDate;
  };

  render() {
    const props = this.props;

    return (
      <View style={[styles.floating, { flex: 0.7 }]}>
        <View style={styles.header}>
          <View style={{ flex: 0.3 }}>
            <Text style={styles.headerText}>{DateUtils.formatDateString(props.selectedDate)}</Text>
          </View>
          <View style={[styles.todayButtonContainer, { flex: 0.4 }]}>
            <Pressable style={styles.todayButton} onPress={this.selectToday}>
              <Text style={[styles.headerText, styles.todayButtonText]}>
                {I18n.t('calendar.today')}
              </Text>
            </Pressable>
          </View>
          <View style={[styles.timeframesContainer, { flex: 0.3 }]}>
            <Pressable onPress={this.setCalendarViewMonth}>
              <Text
                style={[
                  styles.headerText,
                  styles.calendarViewText,
                  {
                    borderBottomWidth: this.state.calendarView === 'month' ? 2 : 0,
                  },
                ]}
              >
                {I18n.ac('calendar.repeatMonthly')}
              </Text>
            </Pressable>

            {/*<Pressable onPress={this.setCalendarViewWeek}>
              <Text
                style={[
                  styles.headerText,
                  styles.calendarViewText,
                  {
                    borderBottomWidth: this.state.calendarView === 'week' ? 2 : 0,
                  },
                ]}
              >
                {I18n.ac('calendar.repeatWeekly')}
              </Text>
            </Pressable>*/}
          </View>
        </View>
        <BigCalendar
          className="main-cal"
          localizer={localizer}
          events={props.events}
          titleAccessor={props.titleAccessor || 'eventName'}
          resourceTitleAccessor="eventId"
          startAccessor="startDate"
          endAccessor="endDate"
          // end common props
          defaultView={this.state.calendarView}
          view={this.state.calendarView}
          getNow={this.getSelectedDate}
          onView={() => {}}
          views={['month']}
          components={{
            eventWrapper: EventWrapperView,
          }}
          step={720}
          selectable
          onDrillDown={this.handleDrillDown}
          onSelectSlot={this.selectSlot}
          onSelectEvent={this.selectEvent}
        />
      </View>
    );
  }
}

class Calendar extends OPComponent {
  constructor(props) {
    super(props);

    const selectedDate = props.selectedDate ? new Date(props.selectedDate) : new Date();

    this.state = {
      selectedDate,
      calendarView: 'month',
      successMessage: null,
      errorMessage: null,
    };
  }

  _dateWithoutTime(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0);
  }

  setSelectedDate = (dateOpts = false) => {
    // if the arg is a Date object, just use that
    if (dateOpts instanceof Date) {
      this.setState({ selectedDate: dateOpts });
      this.props.onSelectedDate(dateOpts);
    } else if (typeof dateOpts === 'number') {
      const { calendarView, selectedDate } = this.state;
      // else incremental date info based on the calendarView
      if (calendarView === 'month') {
        selectedDate.setDate(1);
        selectedDate.setMonth(selectedDate.getMonth() + dateOpts);
      } else {
        let day = calendarView === 'week' ? dateOpts * 7 : 0;
        day = calendarView === 'day' ? dateOpts : day;
        selectedDate.setDate(selectedDate.getDate() + day);
      }
      this.setState({ selectedDate });
      this.props.onSelectedDate(selectedDate);
    }
  };

  handleDismissMessage = (type) => {
    if (type === 'success') {
      this.setState({ successMessage: null });
    } else if (type === 'error') {
      this.setState({ errorMessage: null });
    }
  };

  incrementSelectedDate = () => {
    this.setSelectedDate(1);
  };
  decrementSelectedDate = () => {
    this.setSelectedDate(-1);
  };

  render() {
    const ensureEventDate = (e) => {
      // make sure all the dates are Date objects
      // this was causing issues on web with various components being strings
      if (!(e.startDate instanceof Date)) {
        e.startDate = new Date(e.startDate);
      }
      if (!(e.endDate instanceof Date)) {
        e.endDate = new Date(e.endDate);
      }
      // make sure end date isn't before start date since that messes up rendering
      if (e.endDate < e.startDate) {
        e.endDate = e.startDate;
      }
    };

    const events = [];
    const eventsToday = [];
    const today = new Date(this.state.selectedDate);
    // make sure to reset "today" to midnight for checking today's events
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    // this prevents the state mutation bug!
    this.props.events.forEach((e) => {
      // need a new object to prevent array of references
      const event = { ...e };
      ensureEventDate(event);
      const timeDiff = event.startDate.getTime() - today.getTime();
      if (timeDiff >= 0 && timeDiff < 24 * 60 * 60 * 1000) {
        eventsToday.push(event);
      }
      events.push(event);
    });

    const headerLabel = `${MONTHS[today.getMonth() + 1]} ${today.getFullYear()}`;

    return (
      <Container
        successMessage={this.state.successMessage}
        errorMessage={this.state.errorMessage}
        onDismissMessage={this.handleDismissMessage}
        style={{ ...THEME.container, flex: 1, flexDirection: 'column' }}
      >
        <View
          style={{
            height: 85,
            backgroundColor: COLOR.altContrast,
            borderBottomColor: COLOR.accent,
            borderBottomWidth: 1,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignContent: 'center',
              alignItems: 'center',
              flex: 1,
              marginHorizontal: 'auto',
            }}
          >
            <Pressable style={styles.leftRightArrowContainer} onPress={this.decrementSelectedDate}>
              <Image
                style={styles.leftRightArrow}
                source={require('../../../resources/arrow-left.png')}
              />
            </Pressable>
            <Text
              style={[
                THEME.textRegular,
                {
                  color: COLOR.text,
                  marginHorizontal: 30,
                  minWidth: 400,
                  textAlign: 'center',
                  marginVertical: 'auto',
                  fontWeight: FONT.light.fontWeight,
                  fontSize: FONT_SIZE.enormous,
                },
              ]}
            >
              {headerLabel}
            </Text>
            <Pressable style={styles.leftRightArrowContainer} onPress={this.incrementSelectedDate}>
              <Image
                style={styles.leftRightArrow}
                source={require('../../../resources/arrow-right-hover.png')}
              />
            </Pressable>
          </View>
          <View style={{ position: 'absolute', right: 40, top: 16 }}>
            {this.props.renderMenu()}
          </View>
        </View>

        <View
          style={{
            flex: 1,
            backgroundColor: COLOR.contrast,
          }}
        >
          <View style={{ flexDirection: 'row', flex: 1, padding: 40 }}>
            <AgendaView
              selectedDate={this.state.selectedDate}
              events={eventsToday}
              renderItem={this.props.renderItem}
              isMilitaryEmployer={this.props.isMilitaryEmployer}
            />
            <CalendarView
              selectedDate={this.state.selectedDate}
              setSelectedDate={this.setSelectedDate}
              onSelectEvent={this.props.onSelectEvent}
              events={events}
              titleAccessor={this.props.titleAccessor}
            />
          </View>
        </View>
      </Container>
    );
  }
}

export default Calendar;
